import React, { FC } from "react";
import { ICardTitle } from "./types";
import cn from "classnames";
import {
  CORNER_ELEMENT_AFTER,
  CORNER_ELEMENT_BEFORE,
} from "src/constants/cornerElement";

export const CardTitle: FC<ICardTitle> = ({ name, position }) => (
  <div
    className={cn(
      "absolute top-[9%] left-5 xs:left-14 md:left-[17%] -right-px flex flex-col gap-2 p-2 md:px-6 md:py-3 bg-green-base text-white-base rounded-l-15",
      CORNER_ELEMENT_BEFORE,
      "before:-top-6.25 before:right-px before:shadow-corner-green-base",
      CORNER_ELEMENT_AFTER,
      "after:-bottom-6.25 after:right-px after:shadow-corner-top-right-green-base"
    )}
  >
    <span className="text-lg 2xl:text-24 font-extrabold">{name}</span>
    {position && <span className="text-10 2xl:text-14">{position}</span>}
  </div>
);
